import mainImg from "../../../assets/stain-masala-pullout.webp";
import thumb1 from "../../../assets/stain-masala-pullout.webp";
import thumb2 from "../../../assets/stain-masala-pullout.webp";


import mainImg1 from "../../../assets/satin-side-mounted-pullout.webp";
import thumb3 from "../../../assets/satin-side-mounted-pullout.webp";
import thumb4 from "../../../assets/satin-side-mounted-pullout.webp";

import mainImg2 from "../../../assets/top mounted pullout hanger holder 8 beads.webp";
import thumb5 from "../../../assets/top mounted pullout hanger holder 8 beads-thumb-one.webp";
import thumb6 from "../../../assets/top mounted pullout hanger holder 8 beads-thumb-one.webp";

import mainImg3 from "../../../assets/satin-bottal-pullout(bottam-mounted).webp";
import thumb7 from "../../../assets/satin-bottal-pullout(bottam-mounted).webp";
import thumb8 from "../../../assets/satin-bottal-pullout(bottam-mounted).webp";

import mainImg4 from "../../../assets/grey-wooden-pullout-.jpeg";
import thumb9 from "../../../assets/grey-wooden-pullout-.jpeg";
import thumb10 from "../../../assets/grey-wooden-pullout-.jpeg";


import mainImg5 from "../../../assets/chrome-wooden-pullout(side-mounted).webp";
import thumb11 from "../../../assets/chrome-wooden-pullout(side-mounted).webp";
import thumb12 from "../../../assets/chrome-wooden-pullout(side-mounted).webp";


import mainImg6 from "../../../assets/silver-glass-pulout.jpeg";
import thumb13 from "../../../assets/silver-glass-pulout-one.webp";
import thumb14 from "../../../assets/silver-glass-pulout-two.webp";


import mainImg7 from "../../../assets/pull out grey Double  dustbin-thumb-one.webp";
import thumb15 from "../../../assets/pull out grey Double  dustbin .webp";
import thumb16 from "../../../assets/pull out grey Double  dustbin-thumb-two.webp";


import mainImg8 from "../../../assets/wooden-pull-down.webp";
import thumb17 from "../../../assets/wooden-pull-down.webp";
import thumb18 from "../../../assets/wooden-pull-down.webp";


import mainImg9 from "../../../assets/glass-pantry.jpg";
import thumb19 from "../../../assets/glass-pantry.jpg";
import thumb20 from "../../../assets/glass-pantry.jpg";

import mainImg10 from "../../../assets/larg-pantry.webp";
import thumb21 from "../../../assets/larg-pantry.webp";
import thumb22 from "../../../assets/larg-pantry.webp";



import mainImg11 from "../../../assets/flat-wire-pantry.webp";
import thumb23 from "../../../assets/flat-wire-pantry.webp";
import thumb24 from "../../../assets/flat-wire-pantry.webp";

import mainImg12 from "../../../assets/revolviving-aluminoum-pantry.jpeg";
import thumb25 from "../../../assets/revolviving-aluminoum-pantry.jpeg";
import thumb26 from "../../../assets/revolviving-aluminoum-pantry.jpeg";

// import mainImg13 from "../../../assets/stainless-steel-304-bottle-pullout.webp";
// import thumb27 from "../../../assets/stainless-steel-304-bottle-pullout.webp";
// import thumb28 from "../../../assets/stainless-steel-304-bottle-pullout.webp";



import mainImg14 from "../../../assets/stainless-steel-304-bottle-pullout.webp";
import thumb29 from "../../../assets/stainless-steel-304-bottle-pullout.webp";
import thumb30 from "../../../assets/stainless-steel-304-bottle-pullout.webp";


import mainImg15 from "../../../assets/bottle-pullout-2-shelves.webp";
import thumb31 from "../../../assets/bottle-pullout-2-shelves.webp";
import thumb32 from "../../../assets/bottle-pullout-2-shelves.webp";



import mainImg16 from "../../../assets/bottle-pullout-2-shelves.webp";
import thumb33 from "../../../assets/bottle-pullout-2-shelves.webp";
import thumb34 from "../../../assets/bottle-pullout-2-shelves.webp";

import mainImg17 from "../../../assets/side-mounting-pull-out.webp";
import thumb35 from "../../../assets/side-mounting-pull-out.webp";
import thumb36 from "../../../assets/side-mounting-pull-out.webp";


import mainImg18 from "../../../assets/aluminium-bpo-with-matt.webp";
import thumb37 from "../../../assets/aluminium-bpo-with-matt.webp";
import thumb38 from "../../../assets/aluminium-bpo-with-matt.webp";


import mainImg19 from "../../../assets/glass-pull-dwon.webp";
import thumb39 from "../../../assets/glass-pull-dwon.webp";
import thumb40 from "../../../assets/glass-pull-dwon.webp";

import mainImg20 from "../../../assets/pan-hanger.jpeg";
import thumb41 from "../../../assets/pan-hanger.jpeg";
import thumb42 from "../../../assets/pan-hanger.jpeg";
 
import mainImg21 from "../../../assets/top mounted trouser rack.webp";
import thumb43 from "../../../assets/top mounted trouser rack.webp";
import thumb44 from "../../../assets/top mounted trouser rack.webp";

import mainImg22 from "../../../assets/top mounted trouser rack single.webp";
import thumb45 from "../../../assets/top mounted trouser rack single.webp";
import thumb46 from "../../../assets/top mounted trouser rack single.webp";


import mainImg23 from "../../../assets/side-mounted- trouser- rack-single.webp";
import thumb47 from "../../../assets/side-mounted- trouser- rack-single.webp";
import thumb48 from "../../../assets/side-mounted- trouser- rack-single.webp";

import mainImg24 from "../../../assets/360-roteting-shoe-rack.webp";
import thumb49 from "../../../assets/360-roteting-shoe-rack.webp";
import thumb50 from "../../../assets/360-roteting-shoe-rack.webp";

import mainImg25 from "../../../assets/shoe-rack.webp";
import thumb51 from "../../../assets/shoe-rack.webp";
import thumb52 from "../../../assets/shoe-rack.webp";

import mainImg26 from "../../../assets/gallery.webp";
import thumb53 from "../../../assets/gallery.webp";
import thumb54 from "../../../assets/decoration-shelf.webp";

import mainImg27 from "../../../assets/wooden-pantry-chrome.jpeg";
import thumb55 from "../../../assets/wooden-pantry-chrome.jpeg";
import thumb56 from "../../../assets/wooden-pantry-chrome.jpeg";


import mainImg28 from "../../../assets/premium-glass-elevator.jpeg";
import thumb57 from "../../../assets/premium-glass-elevator.jpeg";
import thumb58 from "../../../assets/premium-glass-elevator.jpeg";


import mainImg29 from "../../../assets/grey-glass-pullouts.jpeg";
import thumb59 from "../../../assets/grey-wooden-pullout-one.webp";
import thumb60 from "../../../assets/grey-wooden-pullout-two.webp";

import mainImg30 from "../../../assets/wooden-pantry.jpeg";
import thumb61 from "../../../assets/wooden-pantry.jpeg";
import thumb62 from "../../../assets/wooden-pantry.jpeg";

import mainImg31 from "../../../assets/quality.webp";
import thumb63 from "../../../assets/quality.webp";
import thumb64 from "../../../assets/quality.webp";


export  const pullOutProducts = [
  {
    code: "PO-01",
    name: "SATIN MASALA PULLOUTS",
    category: "pull-out",

    mainImage: mainImg,

    thumbnails: [thumb1, thumb2],

    short:
      "Satin Masala Pullouts are a smart and space-saving kitchen storage solution designed to keep your spices and small containers perfectly organized. Crafted with a premium satin finish, this pullout unit adds a modern and elegant touch to modular kitchens while ensuring durability and long-lasting performance. The bottom-mounted design provides excellent stability and smooth sliding operation, making daily access effortless.",

    features: [
      "Strong and durable construction",
      "Space-saving hanging design",
      "Easy access to pans and utensils",
      "Suitable for modern modular kitchens",
      "Simple installation and maintenance",
      "code : 7770"
    ],

    video: "https://www.youtube.com/embed/F-8TqHefnB0?si=3ViqTzqcqS4BiLRe",

  /* ✅ PRICE (optional - add later if available) */
  price: "₹12170",
  oldPrice: "₹13180",

  sku: "7608-7609",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=PVC%20Rolling%20Shutter%20600MM%20Inquiry",

/* ✅ SPEC TABLE */
  specTable: [
    {
      item: "PVC Rolling Shutter",
      code: "7608",
      size: "Black",
      finish: "PVC White"
    },
    {
      item: "PVC Rolling Shutter",
      code: "7609",
      size: "Silver",
      finish: "PVC White"
    },
    
  ],

    faq: [
  {
    question: "What are Satin Masala Pullouts?",
    answer:
      "Satin Masala Pullouts are modular kitchen storage solutions designed to store and organize masalas (spices) in pull-out drawers for easy access."
  },
  {
    question: "Where are Satin Masala Pullouts used?",
    answer:
      "They are commonly installed in kitchen cabinets or modular pantry units to keep spice containers organized and easily reachable."
  },
  {
    question: "What are the advantages of Satin Masala Pullouts?",
    answer:
      "They save cabinet space, keep spices neatly arranged, provide smooth pull-out access, and prevent clutter in the kitchen."
  },
  {
    question: "What items can be stored in Satin Masala Pullouts?",
    answer:
      "They are ideal for storing spice jars, small bottles, condiments, and other small kitchen essentials in an organized manner."
  }
],
  },



{
  code: "PO-02",
  name: "SATIN SIDE MOUNTED PULLOUTS",
  category: "pull-out",

  mainImage: mainImg1,
  thumbnails: [thumb3, thumb4],

  // ✅ PRICE
  price: "₹4883",
  oldPrice: "₹1583",
  sku: "7441-7442",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Satin%20Side%20Mounted%20Pullout%20Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/F-8TqHefnB0",

  // ✅ DESCRIPTION
  short:
    "Satin Side Mounted Pullouts are modern kitchen storage solutions designed to maximize cabinet space with smooth accessibility. Built with a durable metal structure and elegant satin finish, these pullouts offer easy sliding functionality and efficient organization for daily kitchen essentials.",

  // ✅ FEATURES
  features: [
    "Side-mounted smooth sliding mechanism",
    "Premium satin finish for modern look",
    "Strong and durable metal construction",
    "Efficient storage for bottles, jars, and utensils",
    "Space-saving design for modular kitchens",
    "Easy access with smooth pull-out system"
  ],

  // ✅ ADDITIONAL INFO (TAB)
  specifications: [
    { label: "Material", value: "Metal" },
    { label: "Finish", value: "Satin" },
    { label: "Mounting", value: "Side Mounted" },
    { label: "Usage", value: "Kitchen Cabinet Storage" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Satin Side Mounted Pullout",
      code: "7441",
      size: "200 mm",
      finish: "Satin"
    },
    {
      item: "Satin Side Mounted Pullout",
      code: "7442",
      size: "250 mm",
      finish: "Satin"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What are Satin Side Mounted Pullouts?",
      answer:
        "They are modular kitchen storage systems mounted on cabinet sides that provide smooth pull-out access and organized storage."
    },
    {
      question: "Where can these pullouts be used?",
      answer:
        "They are used in modular kitchen cabinets and pantry units for storing kitchen essentials efficiently."
    },
    {
      question: "What are the main benefits?",
      answer:
        "They save space, provide smooth operation, and keep items organized and easily accessible."
    },
    {
      question: "What items can be stored?",
      answer:
        "They are ideal for storing bottles, spice jars, condiments, and daily kitchen items."
    }
  ]
},
{
  code: "PO-03",
  name: "TOP MOUNTED PULLOUT HANGER HOLDER – 8 BEADS",
  category: "pull-out",

  mainImage: mainImg2,
  thumbnails: [thumb5, thumb6],

  // ✅ PRICE
  price: "₹2,939",
  oldPrice: "₹3,100",
  sku: "7133",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Top%20Mounted%20Pullout%20Hanger%20Holder%20Inquiry",

  // ✅ VIDEO (change if needed)
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  // ✅ DESCRIPTION
  short:
    "Top Mounted Pullout Hanger Holder with 8 beads is a smart wardrobe storage solution designed for easy access and efficient organization. Installed at the top of cabinets or wardrobes, it smoothly pulls out, allowing convenient hanging and retrieval of clothes. Its 8-bead structure ensures proper spacing, keeping garments wrinkle-free and neatly arranged.",

  // ✅ FEATURES
  features: [
    "Top-mounted design for wardrobes and cabinets",
    "Smooth pull-out sliding mechanism",
    "8-bead structure for multiple hanger support",
    "Keeps clothes organized and wrinkle-free",
    "Compact and space-saving solution",
    "Rust-resistant and durable construction"
  ],

  // ✅ ADDITIONAL INFO (TAB)
  specifications: [
    { label: "Material", value: "Metal" },
    { label: "Finish", value: " Powder Coated" },
    { label: "Mounting", value: "Top Mounted" },
    { label: "Capacity", value: "8 Hangers" },
    { label: "Usage", value: "Wardrobe / Cabinet Storage" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Pullout Hanger Holder – 8 Beads",
      code: "7133",
      size: "Grey",
      finish: ""
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Top Mounted Pullout Hanger Holder?",
      answer:
        "It is a wardrobe storage accessory installed at the top, designed to hold hangers and allow smooth pull-out access."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is mainly used in wardrobes, cabinets, and modular storage units."
    },
    {
      question: "What are its benefits?",
      answer:
        "It saves space, keeps clothes organized, and provides easy accessibility."
    },
    {
      question: "How many hangers can it hold?",
      answer:
        "This model can hold up to 8 hangers efficiently."
    }
  ]
},



  {
  code: "PO-04",
  name: "SATIN BOTTLE PULLOUTS (BOTTOM MOUNTED)",
  category: "pull-out",

  mainImage: mainImg3,
  thumbnails: [thumb7, thumb8],

  // ✅ PRICE
  price: "₹3584",
  oldPrice: "₹4000",
  sku: "7109 -7227",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Satin%20Bottle%20Pullout%20Inquiry",

  // ✅ VIDEO (change if needed)
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ DESCRIPTION
  short:
    "Satin Bottle Pullouts (Bottom Mounted) are smart kitchen storage solutions designed to organize bottles and tall containers efficiently. Built with a durable structure and elegant satin finish, these pullouts feature a bottom-mounted sliding system that ensures smooth and stable operation, making everyday kitchen access convenient and organized.",

  // ✅ FEATURES
  features: [
    "Bottom-mounted sliding system for extra stability",
    "Premium satin finish for modern kitchens",
    "Ideal for storing bottles and tall containers",
    "Smooth pull-out mechanism for easy access",
    "Prevents bottles from tipping or falling",
    "Strong, durable and rust-resistant design"
  ],

  // ✅ ADDITIONAL INFO (TAB)
  specifications: [
    { label: "Material", value: "Metal" },
    { label: "Finish", value: "Satin" },
    { label: "Mounting", value: "Bottom Mounted" },
    { label: "Usage", value: "Kitchen Bottle Storage" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Satin Bottle Pullout",
      code: "7109",
      size: "150 mm",
      finish: "Satin"
    },
    {
      item: "Satin Bottle Pullout",
      code: "7110",
      size: "200 mm",
      finish: "Satin"
    },
    {
      item: "Satin Bottle Pullout",
      code: "7111",
      size: "150 mm",
      finish: "Satin"
    },
    {
      item: "Satin Bottle Pullout",
      code: "7226",
      size: "300 mm",
      finish: "Satin"
    },
    {
      item: "Satin Bottle Pullout",
      code: "7227",
      size: "350 mm",
      finish: "Satin"
    },
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What are Satin Bottle Pullouts (Bottom Mounted)?",
      answer:
        "They are kitchen storage units designed to hold bottles, installed at the bottom of cabinets for smooth and stable pull-out access."
    },
    {
      question: "Where can they be used?",
      answer:
        "They are used in modular kitchen cabinets and pantry units to store bottles and tall containers."
    },
    {
      question: "What are the advantages?",
      answer:
        "They provide stability, prevent bottles from tipping, and keep kitchen items organized."
    },
    {
      question: "What items can be stored?",
      answer:
        "They are ideal for storing water bottles, oil bottles, sauces, and tall kitchen containers."
    }
  ]
},
  
 {
  code: "PO-05",
  name: "GREY WOODEN PULLOUTS (SIDE MOUNTED)",
  category: "pull-out",

  mainImage: mainImg4,
  thumbnails: [thumb9, thumb10],

  short:
    "Grey Wooden Pullouts (Side Mounted) are premium storage solutions designed for modular kitchens and cabinets. Featuring a stylish grey wooden finish and side-mounted sliding system, these pullouts ensure smooth operation and organized storage of kitchen essentials while enhancing the overall interior look.",

  features: [
    "Side-mounted sliding system for smooth movement",
    "Elegant grey wooden finish for modern interiors",
    "Strong and durable wooden construction",
    "Ideal for storing jars, bottles, and kitchen items",
    "Space-saving and organized storage solution",
    "Easy to install and maintain",
  ],

  // ✅ VIDEO (add when available)
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE (update if needed)
  price: "₹4613",
  oldPrice: "₹4900",

  sku: "7602 - 7605",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Grey%20Wooden%20Pullout%20Inquiry",

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "GREY WOODEN PULLOUTS",
      code: "7602",
      size: "200 mm",
      finish: "Grey Wooden"
    },
    {
      item: "GREY WOODEN PULLOUTS",
      code: "7603",
      size: "250 mm",
      finish: "Grey Wooden"
    },
    {
      item: "GREY WOODEN PULLOUTS",
      code: "7604",
      size: "300 mm",
      finish: "Grey Wooden"
    },
    {
      item: "GREY WOODEN PULLOUTS",
      code: "7605 ",
      size: "350 mm",
      finish: "Grey Wooden"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What are Grey Wooden Pullouts (Side Mounted)?",
      answer:
        "Grey Wooden Pullouts (Side Mounted) are modular kitchen storage units made from durable wood with a modern grey finish, designed for smooth pull-out access and organized storage."
    },
    {
      question: "Where are Grey Wooden Pullouts used?",
      answer:
        "They are commonly installed in modular kitchens, cabinets, and pantry units to store utensils, bottles, jars, and daily kitchen essentials."
    },
    {
      question: "What are the advantages of Grey Wooden Pullouts?",
      answer:
        "They provide smooth sliding, enhance kitchen aesthetics, save space, and keep items organized and easily accessible."
    },
    {
      question: "What items can be stored in Grey Wooden Pullouts?",
      answer:
        "They are ideal for storing spice jars, bottles, utensils, condiments, and other kitchen essentials."
    }
  ]
},
  
{
  code: "PO-06",
  name: "CHROME WOODEN PULLOUTS (SIDE MOUNTED)",
  category: "pull-out",

  mainImage: mainImg5,
  thumbnails: [thumb11, thumb12],

  short:
    "Chrome Wooden Pullouts (Side Mounted) are stylish and durable storage solutions designed for modular kitchens and cabinets. Featuring a strong chrome-finish metal frame combined with wooden shelves, these pullouts offer both strength and elegance. The side-mounted sliding mechanism ensures smooth movement and easy access to stored kitchen essentials.",

  features: [
    "Chrome-finish metal frame for durability and modern look",
    "Wooden shelves provide strength and reduce noise",
    "Side-mounted channels ensure smooth and stable movement",
    "Secure railing design prevents items from falling",
    "Ideal for storing jars, bottles, groceries, and utensils",
    "Suitable for modular kitchen cabinets and pantry units"
  ],

  // ✅ VIDEO (add if available)
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹4613",
  oldPrice: "₹4700",

  sku: "7481-7484",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Chrome%20Wooden%20Pullout%20Inquiry",

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "CHROME WOODEN PULLOUTS",
      code: "7481",
      size: "200mm",
      finish: "Chrome + Wooden"
    },
    {
      item: "CHROME WOODEN PULLOUTS",
      code: "7482",
      size: "250mm",
      finish: "Chrome + Wooden"
    },
    {
      item: "CHROME WOODEN PULLOUTS",
      code: "7483",
      size: "300mm",
      finish: "Chrome + Wooden"
    },
    {
      item: "CHROME WOODEN PULLOUTS",
      code: "7484",
      size: "350mm",
      finish: "Chrome + Wooden"
    },
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What are Chrome Wooden Pullouts (Side Mounted)?",
      answer:
        "Chrome Wooden Pullouts are modular kitchen storage units that combine a chrome metal frame with wooden shelves, designed for smooth pull-out access and organized storage."
    },
    {
      question: "Where are Chrome Wooden Pullouts used?",
      answer:
        "They are commonly installed in modular kitchens, cabinets, and pantry units to store utensils, jars, bottles, and daily kitchen essentials."
    },
    {
      question: "What are the advantages of Chrome Wooden Pullouts?",
      answer:
        "They provide strong support, smooth sliding operation, stylish appearance, and keep kitchen items well-organized and easily accessible."
    },
    {
      question: "What items can be stored in Chrome Wooden Pullouts?",
      answer:
        "They are ideal for storing spice jars, bottles, groceries, utensils, and other kitchen essentials."
    }
  ]
},


{
  code: "PO-07",
  name: "SILVER GLASS PULLOUTS (SIDE MOUNTED)",
  category: "pull-out",

  mainImage: mainImg6,
  thumbnails: [thumb13, thumb14],

  short:
    "Silver Glass Pullouts (Side Mounted) are premium storage solutions designed for modern modular kitchens. Featuring a strong silver-finish metal frame combined with toughened glass sides, these pullouts offer durability, visibility, and elegance. The side-mounted sliding system ensures smooth movement and easy access to kitchen essentials.",

  features: [
    "Toughened glass sides for clear visibility of stored items",
    "Silver-finish metal frame for strength and modern look",
    "Side-mounted channels ensure smooth and balanced sliding",
    "Glass panels prevent items from falling during use",
    "Ideal for storing jars, bottles, spices, and kitchen essentials",
    "Sleek and space-saving design for modular cabinets"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹4883",
  oldPrice: "₹5888",

  sku: "7439",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Silver%20Glass%20Pullout%20Inquiry",

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "SILVER GLASS PULLOUTS",
      code: "7439",
      size: "200mm",
      finish: "Silver + Glass"
    },
    {
      item: "SILVER GLASS PULLOUTS",
      code: "7440",
      size: "250mm",
      finish: "Silver + Glass"
    },
    {
      item: "SILVER GLASS PULLOUTS",
      code: "7475",
      size: "300mm",
      finish: "Silver + Glass"
    },
     {
      item: "SILVER GLASS PULLOUTS",
      code: "7476",
      size: "350mm",
      finish: "Silver + Glass"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What are Silver Glass Pullouts (Side Mounted)?",
      answer:
        "Silver Glass Pullouts are modular kitchen storage units featuring a silver metal frame with glass sides, designed for smooth pull-out access and organized storage."
    },
    {
      question: "Where are Silver Glass Pullouts used?",
      answer:
        "They are commonly installed in modular kitchens, cabinets, and pantry units to store jars, bottles, condiments, and kitchen essentials."
    },
    {
      question: "What are the advantages of Silver Glass Pullouts?",
      answer:
        "They provide smooth sliding, clear visibility, modern aesthetics, and help keep kitchen items organized and easily accessible."
    },
    {
      question: "What items can be stored in Silver Glass Pullouts?",
      answer:
        "They are ideal for storing spice jars, bottles, utensils, condiments, and daily kitchen items."
    }
  ]
},



  {
  code: "PO-08",
  name: "PULL OUT GREY DOUBLE DUSTBIN",
  category: "pull-out",

  mainImage: mainImg7,
  thumbnails: [thumb15, thumb16],

  short:
    "Pull Out Grey Double Dustbin is a smart and hygienic waste management solution designed for modular kitchen cabinets. It features two separate bins within a smooth pull-out frame, allowing easy segregation of dry and wet waste while keeping the kitchen clean and organized.",

  features: [
    "Dual bins for efficient dry and wet waste segregation",
    "Smooth pull-out mechanism for easy and hygienic use",
    "Strong plastic bins with durable metal frame support",
    "Space-saving design that fits inside kitchen cabinets",
    "Keeps waste concealed for a clean kitchen look",
    "Easy to remove bins for cleaning and disposal"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹4693",
  oldPrice: "₹6450",

  sku: "7114",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Double%20Dustbin%20Pullout%20Inquiry",

  // ✅ ADDITIONAL INFO (IMPORTANT 🔥)
  specifications: [
    { label: "Material", value: "Plastic Bin + Metal Frame" },
    { label: "Finish", value: "Grey" },
    { label: "Mounting Type", value: "Bottom Mounted" },
    { label: "Capacity", value: "2 x 15L / 2 x 20L" },
    { label: "Usage", value: "Kitchen Waste Management" },
    { label: "Installation", value: "Cabinet Base Unit" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "DOUBLE DUSTBIN PULLOUT",
      code: "7114",
      size: "22 Litre",
      finish: "Grey"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Pull Out Grey Double Dustbin?",
      answer:
        "It is a modular kitchen waste management system with two bins mounted inside a cabinet, designed for easy pull-out access and waste segregation."
    },
    {
      question: "Where is the Pull Out Grey Double Dustbin used?",
      answer:
        "It is commonly installed in base cabinets or under-sink areas of modular kitchens to manage household waste efficiently."
    },
    {
      question: "What are the advantages of a Pull Out Double Dustbin?",
      answer:
        "It saves space, keeps waste hidden, allows easy segregation of dry and wet waste, and ensures hygienic disposal."
    },
    {
      question: "Is the dustbin easy to clean?",
      answer:
        "Yes, the bins can be easily removed and cleaned, making maintenance simple and convenient."
    }
  ]
},


   {
  code: "PO-09",
  name: "WOODEN PULL DOWN",
  category: "pull-out",

  mainImage: mainImg8,
  thumbnails: [thumb17, thumb18],

  short:
    "Wooden Pull Down is a smart and ergonomic storage solution designed for overhead kitchen cabinets. It allows users to easily pull down upper shelves to a comfortable height, making items accessible without the need for a stool. The wooden base ensures durability while maintaining a premium and elegant cabinet appearance.",

  features: [
    "Ideal for overhead wall cabinets",
    "Pull-down mechanism for easy reach access",
    "Strong wooden base for stable storage",
    "Smooth lifting and lowering system",
    "Perfect for storing plates, cups, and kitchen essentials",
    "Space-saving and ergonomic design"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹16713",
  oldPrice: "₹17900",

  sku: "7473-7474",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Wooden%20Pull%20Down%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Wood + Metal Mechanism" },
    { label: "Finish", value: "Wooden" },
    { label: "Mounting Type", value: "Wall Cabinet (Top Mounted)" },
    { label: "Function", value: "Pull Down Storage System" },
    { label: "Usage", value: "Kitchen Overhead Storage" },
    { label: "Load Capacity", value: "Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "WOODEN PULL DOWN",
      code: "7473",
      size: "600 mm",
      finish: "Wooden"
    },
    {
      item: "WOODEN PULL DOWN",
      code: "7474",
      size: "900 mm",
      finish: "Wooden"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Wooden Pull Down?",
      answer:
        "Wooden Pull Down is a modular kitchen accessory that allows upper cabinet shelves to be pulled down easily for better accessibility."
    },
    {
      question: "Where is Wooden Pull Down used?",
      answer:
        "It is installed in overhead kitchen cabinets to make high storage spaces easily accessible."
    },
    {
      question: "What are the advantages of Wooden Pull Down?",
      answer:
        "It improves accessibility, reduces effort, saves space, and provides smooth and controlled movement."
    },
    {
      question: "What items can be stored in a Wooden Pull Down?",
      answer:
        "It is ideal for storing plates, cups, glasses, and everyday kitchen essentials."
    }
  ]
},


  {
  code: "PO-10",
  name: "SILVER GLASS PANTRY (With Bidding)",
  category: "pull-out",

  mainImage: mainImg9,
  thumbnails: [thumb19, thumb20],

  short:
    "Silver GLASS PANTRY (With Bidding) is a premium tall storage solution designed for modular kitchens to organize groceries, jars, and daily essentials efficiently. It features a strong metal frame with glass baskets that offer clear visibility while maintaining a modern and elegant look. The full pull-out mechanism ensures smooth access to all stored items.",

  features: [
    "Full-height pantry design for maximum storage capacity",
    "Grey Glass baskets for clear visibility of stored items",
    "Smooth pull-out mechanism for easy access",
    "Ideal for storing groceries, jars, bottles, and containers",
    "Strong metal frame for durability and long life",
    "Modern and stylish design for modular kitchens"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹17738",
  oldPrice: "₹18000",

  sku: "7088-7089",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Glass%20Pantry%20Unit%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Glass + Metal Frame" },
    { label: "Finish", value: "Silver / Glass" },
    { label: "Mounting Type", value: "Tall Unit (Full Height)" },
    { label: "Usage", value: "Pantry Storage" },
    { label: "No. of Shelves", value: "4 - 6 Shelves" },
    { label: "Load Capacity", value: "Medium to Heavy Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "GLASS PANTRY UNIT",
      code: "7088",
      size: "450mm x 6L",
      finish: "Glass + Silver"
    },
    {
      item: "GLASS PANTRY UNIT",
      code: "7089",
      size: "600mm X 6L",
      finish: "Glass + Silver"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Glass Pantry Unit?",
      answer:
        "A Glass Pantry Unit is a modular kitchen storage system with glass baskets, designed to keep pantry items visible and well organized."
    },
    {
      question: "Where is the Glass Pantry Unit used?",
      answer:
        "It is installed in tall kitchen cabinets or pantry units to store groceries, jars, and daily-use items efficiently."
    },
    {
      question: "What are the advantages of a Glass Pantry Unit?",
      answer:
        "It offers full visibility, maximizes storage space, ensures easy access, and adds a modern premium look to the kitchen."
    },
    {
      question: "What items can be stored in a Glass Pantry Unit?",
      answer:
        "It is ideal for storing dry food, spices, jars, bottles, and other pantry essentials."
    }
  ]
},




{
    code: "PO-11",
    name: "LARGE ORGANISERS PANTRY UNIT (12 BAXKETS) ",
    category: "pull-out",

    mainImage: mainImg10,

    thumbnails: [thumb21, thumb22],

    short:
      "Large Organisers Pantry Unit with 12 Baskets is a high-capacity storage system designed for tall kitchen cabinets. It features multiple baskets arranged vertically to organize groceries, jars, bottles, and daily-use items in a structured way. The pullout mechanism allows the entire unit to slide out smoothly, giving full visibility and easy access to all baskets at once.",

    features: [
      "12 baskets for maximum storage and segregation",
      "Full-height pullout design for tall cabinets",
      "Ideal for groceries, bottles, jars, and packets",
      "Smooth sliding system for easy access to all levels",
      "Strong metal frame supporting multiple loaded baskets",
      "Helps keep pantry items neatly organizedHelps maintain a well-organized pantry section",
    ],
    faq: [
  {
    question: "What is a Large Organisers Pantry Unit (12 Baskets)?",
    answer:
      "A Large Organisers Pantry Unit (12 Baskets) is a modular kitchen storage system with 12 baskets, designed to organize pantry items efficiently and keep them easily accessible."
  },
  {
    question: "Where is the Large Organisers Pantry Unit (12 Baskets) used?",
    answer:
      "It is commonly installed in modular kitchens or pantry cabinets to organize food items, utensils, and other kitchen essentials."
  },
  {
    question: "What are the advantages of the Large Organisers Pantry Unit (12 Baskets)?",
    answer:
      "It maximizes storage space, keeps pantry items organized, allows easy access to each basket, and helps maintain a clutter-free kitchen."
  },
  {
    question: "What items can be stored in the Large Organisers Pantry Unit (12 Baskets)?",
    answer:
      "It is ideal for storing dry food, snacks, jars, bottles, utensils, and other kitchen essentials in an organized manner."
  }
],
  },


  
  {
    code: "PO-12",
    name: "FLAT WIRE PANTRY UNIT  ",
    category: "pull-out",

    mainImage: mainImg11,

    thumbnails: [thumb23, thumb24],

    short:
      "Flat Wire Pantry Unit is a tall and efficient storage system designed for modular kitchen cabinets. It features flat wire baskets arranged vertically to organize groceries, jars, bottles, and kitchen essentials in a neat and visible manner. The pullout mechanism allows the entire unit to slide out smoothly for easy access to all stored items.",

    features: [
      "Flat wire baskets for clear visibility and ventilation",
      "Smooth sliding mechanism for easy access",
      "Helps maintain an organized pantry section",
      "Suitable for tall modular kitchen cabinets",
      "Easy installation and low maintenance",
     
    ],
    faq: [
  {
    question: "What is a Flat Wire Pantry Unit?",
    answer:
      "A Flat Wire Pantry Unit is a modular kitchen storage solution with flat wire baskets, designed to store pantry items efficiently while providing ventilation and easy access."
  },
  {
    question: "Where is the Flat Wire Pantry Unit used?",
    answer:
      "It is commonly installed in modular kitchens or pantry cabinets to organize food items, jars, bottles, and other kitchen essentials."
  },
  {
    question: "What are the advantages of a Flat Wire Pantry Unit?",
    answer:
      "It keeps items visible, maximizes cabinet storage, provides ventilation, and helps maintain an organized, clutter-free kitchen."
  },
  {
    question: "What items can be stored in the Flat Wire Pantry Unit?",
    answer:
      "It is ideal for storing dry food, snacks, jars, bottles, and other kitchen essentials in an organized manner."
  }
],
  },


  {
  code: "PO-13",
  name: "REVOLVING ALUMINIUM PANTRY",
  category: "pull-out",

  mainImage: mainImg12,
  thumbnails: [thumb25, thumb26],

  short:
    "Revolving Aluminium Pantry is a smart and space-efficient storage solution designed for tall kitchen cabinets. Made from high-quality aluminium, it is lightweight, rust-resistant, and durable. The revolving mechanism allows smooth 360-degree rotation, providing easy access to all stored items from any angle.",

  features: [
    "360-degree revolving mechanism for easy access",
    "Made from lightweight and rust-resistant aluminium",
    "Ideal for storing groceries, jars, and containers",
    "Smooth rotation for convenient daily use",
    "Perfect for tall pantry cabinets",
    "Space-saving and highly functional design"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹27004",
  oldPrice: "₹28500",

  sku: "7741",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Revolving%20Aluminium%20Pantry%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Aluminium" },
    { label: "Finish", value: "Silver" },
    { label: "Function", value: "Revolving Pantry System" },
    { label: "Usage", value: "Tall Kitchen Cabinet" },
    { label: "Rotation", value: "360 Degree" },
    { label: "Load Capacity", value: "Medium to Heavy Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "REVOLVING ALUMINIUM PANTRY",
      code: "7741",
      size: "600mm Anthracite",
      finish: "Aluminium"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Revolving Aluminium Pantry?",
      answer:
        "It is a tall kitchen storage system with rotating shelves that provide easy access to items from all sides."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in tall kitchen cabinets to store groceries and pantry items efficiently."
    },
    {
      question: "What are the advantages?",
      answer:
        "It saves space, offers 360-degree access, and keeps items organized with smooth rotation."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing jars, groceries, bottles, and kitchen essentials."
    }
  ]
},


   {
  code: "PO-15",
  name: "STAINLESS STEEL BOTTLE PULLOUTS 3 SHELVES",
  category: "pull-out",

  mainImage: mainImg14,
  thumbnails: [thumb29, thumb30],

  short:
    "Stainless Steel Bottle Pullouts are durable and efficient storage solutions designed for modular kitchen cabinets. Made from high-quality stainless steel, they offer excellent strength, corrosion resistance, and long service life. The smooth pullout mechanism ensures easy access to bottles and containers while keeping them neatly organized.",

  features: [
    "High-quality stainless steel construction for durability",
    "Rust-resistant and long-lasting performance",
    "Ideal for storing bottles, jars, and tall containers",
    "Smooth pullout mechanism for easy access",
    "Wire design allows ventilation and visibility",
    "Perfect for narrow kitchen cabinet spaces"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹13500",
  oldPrice: "₹14900",

  sku: "FLM164-168",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Stainless%20Steel%20Bottle%20Pullout%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Finish", value: "Steel" },
    { label: "Mounting Type", value: "Base Cabinet" },
    { label: "Usage", value: "Bottle Storage" },
    { label: "Design", value: "Wire Basket" },
    { label: "Load Capacity", value: "Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "STAINLESS STEEL BOTTLE PULLOUT",
      code: "FLM 164",
      size: "4.20.21",
      finish: "Steel"
    },
    {
      item: "STAINLESS STEEL BOTTLE PULLOUT",
      code: "FLM 165",
      size: "6.20.21",
      finish: "Steel"
    },
    {
      item: "STAINLESS STEEL BOTTLE PULLOUT",
      code: "FLM 166",
      size: "8.20.21",
      finish: "Steel"
    },
    {
      item: "STAINLESS STEEL BOTTLE PULLOUT",
      code: "FLM 167",
      size: "11.20.21",
      finish: "Steel"
    },
    {
      item: "STAINLESS STEEL BOTTLE PULLOUT",
      code: "FLM 168",
      size: "15.20.21",
      finish: "Steel"
    },
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What are Stainless Steel Bottle Pullouts?",
      answer:
        "They are modular kitchen storage units made from stainless steel designed to hold bottles with smooth pull-out access."
    },
    {
      question: "Where are they used?",
      answer:
        "They are installed in kitchen cabinets to store bottles, jars, and tall containers efficiently."
    },
    {
      question: "What are the advantages?",
      answer:
        "They provide durability, rust resistance, organized storage, and smooth operation."
    },
    {
      question: "What items can be stored?",
      answer:
        "They are ideal for storing water bottles, oil bottles, jars, and kitchen containers."
    }
  ]
},


  {
  code: "PO-16",
  name: "BOTTLE PULLOUT – 2 SHELVES",
  category: "pull-out",

  mainImage: mainImg15,
  thumbnails: [thumb31, thumb32],

  short:
    "Bottle Pullout with 2 Shelves is a compact and efficient storage solution designed for modular kitchen cabinets. It provides organized space for bottles, jars, and tall containers, ensuring easy access through a smooth pullout mechanism. Its slim design makes it ideal for narrow cabinet spaces.",

  features: [
    "Two shelves for organized bottle and jar storage",
    "Smooth pullout mechanism for easy access",
    "Ideal for narrow kitchen cabinet spaces",
    "Suitable for storing oils, sauces, and bottles",
    "Durable construction for long-term use",
    "Compact design for space-saving installation"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹5391",
  oldPrice: "₹6000",

  sku: "PACP 50-53",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Bottle%20Pullout%202%20Shelves%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Steel / Stainless Steel" },
    { label: "Finish", value: "Chrome / Steel" },
    { label: "Shelves", value: "2" },
    { label: "Mounting Type", value: "Base Cabinet" },
    { label: "Usage", value: "Bottle Storage" },
    { label: "Load Capacity", value: "Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "BOTTLE PULLOUT – 2 SHELVES",
      code: "FLM 169",
      size: "15.20.18",
      finish: "Steel"
    },
    {
      item: "BOTTLE PULLOUT – 2 SHELVES",
      code: "FLM 170",
      size: "4.20.18",
      finish: "Steel"
    },
    {
      item: "BOTTLE PULLOUT – 2 SHELVES",
      code: "FLM 171",
      size: "6.20.18",
      finish: "Steel"
    },
    {
      item: "BOTTLE PULLOUT – 2 SHELVES",
      code: "FLM 172",
      size: "8.20.18",
      finish: "Steel"
    },
    {
      item: "BOTTLE PULLOUT – 2 SHELVES",
      code: "FLM 173",
      size: "11.20.18",
      finish: "Steel"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Bottle Pullout – 2 Shelves?",
      answer:
        "It is a modular kitchen storage unit with two shelves designed to store bottles with smooth pull-out access."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in kitchen cabinets to organize bottles and containers efficiently."
    },
    {
      question: "What are the advantages?",
      answer:
        "It saves space, keeps bottles organized, and provides easy access with smooth sliding."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing oil bottles, sauces, jars, and kitchen containers."
    }
  ]
},

//  {
//   code: "PO-17",
//   name: "STAINLESS STEEL SHEET PULL OUT – 2 SHELVES",
//   category: "pull-out",

//   mainImage: mainImg16,
//   thumbnails: [thumb33, thumb34],

//   short:
//     "Stainless Steel Sheet Pull Out with 2 Shelves is a strong and reliable storage solution for modular kitchen cabinets. Made from high-quality stainless steel sheet, it offers a solid base without gaps, making it ideal for storing jars, containers, and kitchen essentials safely. The smooth pullout mechanism ensures easy access and organized storage.",

//   features: [
//     "Solid stainless steel sheet base for better support",
//     "Two shelves for organized storage of containers and jars",
//     "Smooth pullout mechanism for easy access",
//     "Suitable for medium to heavy kitchen items",
//     "Ideal for base cabinets in modular kitchens",
//     "Durable and rust-resistant construction"
//   ],

//   // ✅ VIDEO
//   video: "https://www.youtube.com/embed/PM5WhdOWrqo",

//   // ✅ PRICE
//   price: "₹11200",
//   oldPrice: "₹12500",

//   sku: "7636",
//   stock: "In Stock",

//   catalogue: "/Slimline Price List-2026.pdf",
//   inquiry:
//     "https://wa.me/919650100908?text=SS%20Sheet%20Pullout%202%20Shelves%20Inquiry",

//   // ✅ ADDITIONAL INFO
//   specifications: [
//     { label: "Material", value: "Stainless Steel Sheet" },
//     { label: "Finish", value: "Steel" },
//     { label: "Shelves", value: "2" },
//     { label: "Mounting Type", value: "Base Cabinet" },
//     { label: "Usage", value: "Kitchen Storage" },
//     { label: "Load Capacity", value: "Medium to Heavy Duty" }
//   ],

//   // ✅ SPEC TABLE
//   specTable: [
//     {
//       item: "SS SHEET PULL OUT – 2 SHELVES",
//       code: "7636",
//       size: "450 mm",
//       finish: "Steel"
//     },
//     {
//       item: "SS SHEET PULL OUT – 2 SHELVES",
//       code: "7637",
//       size: "600 mm",
//       finish: "Steel"
//     },
//     {
//       item: "SS SHEET PULL OUT – 2 SHELVES",
//       code: "7637",
//       size: "600 mm",
//       finish: "Steel"
//     },
//     {
//       item: "SS SHEET PULL OUT – 2 SHELVES",
//       code: "7637",
//       size: "600 mm",
//       finish: "Steel"
//     },
//   ],

//   // ✅ FAQ
//   faq: [
//     {
//       question: "What is a Stainless Steel Sheet Pull Out – 2 Shelves?",
//       answer:
//         "It is a modular kitchen storage unit made from stainless steel sheet with two shelves for organized storage and smooth pull-out access."
//     },
//     {
//       question: "Where is it used?",
//       answer:
//         "It is installed in kitchen base cabinets to store jars, containers, and kitchen essentials efficiently."
//     },
//     {
//       question: "What are the advantages?",
//       answer:
//         "It provides strong support, durability, rust resistance, and smooth sliding operation for easy access."
//     },
//     {
//       question: "What items can be stored?",
//       answer:
//         "It is ideal for storing containers, jars, utensils, and medium to heavy kitchen items."
//     }
//   ]
// },



//   {
//     code: "PO-18",
//     name: "SIDE MOUNTING PULL OUT",
//     category: "pull-out",

//     mainImage: mainImg17,

//     thumbnails: [thumb35, thumb36],

//     short:
//       "SIDE MOUNTING PULL OUTSide Mounting Pull Out is a convenient storage solution designed for modular kitchen cabinets. Installed with side-mounted channels, it offers smooth sliding movement and easy access to stored items. This pullout helps in organizing jars, containers, bottles, and kitchen essentials in a neat and accessible manner.",

//     features: [
//       "Side-mounted channels for balanced and smooth sliding",
//       "Ideal for storing jars, bottles, and kitchen containers",
//       "Suitable for mid-size and tall kitchen cabinets",
//       "Open design for clear visibility of stored items",
//       "Strong metal construction for daily kitchen use",
     
//     ],
//     faq: [
//   {
//     question: "What is a Side Mounting Pull Out?",
//     answer:
//       "A Side Mounting Pull Out is a modular kitchen storage unit that mounts to the side of cabinets, providing smooth pull-out access for organized storage."
//   },
//   {
//     question: "Where is the Side Mounting Pull Out used?",
//     answer:
//       "It is commonly installed in kitchen base cabinets or pantry units to store bottles, jars, utensils, or other kitchen essentials efficiently."
//   },
//   {
//     question: "What are the advantages of the Side Mounting Pull Out?",
//     answer:
//       "It saves space, allows easy access to stored items, keeps kitchen essentials organized, and provides smooth pull-out operation."
//   },
//   {
//     question: "What items can be stored in the Side Mounting Pull Out?",
//     answer:
//       "It is ideal for storing bottles, jars, utensils, condiments, and other small to medium kitchen essentials."
//   }
// ],
//   },


  {
  code: "PO-19",
  name: "ALUMINIUM BPO WITH MATT",
  category: "pull-out",

  mainImage: mainImg18,
  thumbnails: [thumb37, thumb38],

  short:
    "Aluminium BPO with Matt finish is a modern bottle pullout designed for modular kitchen cabinets. Made from lightweight and rust-resistant aluminium, it offers durability with a clean matte appearance. The smooth pullout mechanism allows easy access to bottles, jars, and containers while keeping them neatly organized.",

  features: [
    "Aluminium construction with premium matte finish",
    "Smooth pullout mechanism for easy daily use",
    "Lightweight yet strong and durable structure",
    "Ideal for narrow cabinet spaces beside hob or sink",
    "Open basket design for visibility and airflow",
    "Rust-resistant for long-lasting performance"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹5490",
  oldPrice: "₹6000",

  sku: "7744-7746",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Aluminium%20BPO%20Matt%20Pullout%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Aluminium" },
    { label: "Finish", value: "Matt" },
    { label: "Mounting Type", value: "Base Cabinet" },
    { label: "Usage", value: "Bottle & Kitchen Storage" },
    { label: "Design", value: "Open Basket" },
    { label: "Load Capacity", value: "Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "ALUMINIUM BPO WITH MATT",
      code: "7744",
      size: "200mm",
      finish: "Matt Aluminium"
    },
    {
      item: "ALUMINIUM BPO WITH MATT",
      code: "7745",
      size: "250mm",
      finish: "Matt Aluminium"
    },
    {
      item: "ALUMINIUM BPO WITH MATT",
      code: "7746",
      size: "300mm",
      finish: "Matt Aluminium"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is Aluminium BPO with Matt?",
      answer:
        "It is a modular kitchen pullout unit made of aluminium with a matte finish, designed for organized bottle storage with smooth pull-out access."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in kitchen base cabinets or pantry units to store bottles and kitchen essentials efficiently."
    },
    {
      question: "What are the advantages?",
      answer:
        "It is lightweight, rust-resistant, stylish, and provides smooth sliding operation with organized storage."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing bottles, jars, condiments, and kitchen containers."
    }
  ]
},
 {
  code: "PO-20",
  name: "GLASS PULL DOWN",
  category: "pull-out",

  mainImage: mainImg19,
  thumbnails: [thumb39, thumb40],

  short:
    "Glass Pull Down is a modern wall cabinet accessory designed to provide easy access to upper storage areas. Made with a strong aluminium frame and premium glass shelves, it offers durability along with an elegant appearance. The smooth pull-down mechanism allows users to bring upper cabinet items to a comfortable height, making it convenient and safe to use. It maximizes vertical space while maintaining a clean and organized kitchen setup.",

  features: [
    "Smooth and easy pull-down mechanism",
    "Premium glass shelves for modern look",
    "Strong aluminium structure for durability",
    "Ideal for wall-mounted kitchen cabinets",
    "Space-saving and user-friendly design",
    "Safe and convenient access to upper storage"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹15648",
  oldPrice: "₹16900",

  sku: "7436-7437",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Glass%20Pull%20Down%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Aluminium + Glass" },
    { label: "Finish", value: "Glass + Aluminium Frame" },
    { label: "Mounting Type", value: "Wall Cabinet" },
    { label: "Usage", value: "Upper Storage Access" },
    { label: "Operation", value: "Pull Down Mechanism" },
    { label: "Load Capacity", value: "Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "GLASS PULL DOWN",
      code: "7436",
      size: "600mm",
      finish: "Glass + Aluminium"
    },
    {
      item: "GLASS PULL DOWN",
      code: "7437",
      size: "900mm",
      finish: "Glass + Aluminium"
    },
   
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Glass Pull Down?",
      answer:
        "Glass Pull Down is a modular kitchen accessory that allows upper cabinets to be pulled down smoothly for easy access."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in wall-mounted kitchen cabinets to make upper storage easily reachable."
    },
    {
      question: "What are the advantages?",
      answer:
        "It improves accessibility, saves space, provides smooth operation, and gives a modern glass finish to the kitchen."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing dishes, cups, glasses, and daily-use kitchen items."
    }
  ]
},
{
  code: "PO-21",
  name: "PAN HANGER RACK",
  category: "pull-out",

  mainImage: mainImg20,
  thumbnails: [thumb41, thumb42],

  short:
    "Pan Hanger Rack is a smart kitchen storage solution designed to organize pans, pots, and lids efficiently. It allows cookware to be hung neatly, making them easily accessible while saving cabinet space. The sturdy metal construction ensures durability, and the open hanging design provides clear visibility and quick access to all items.",

  features: [
    "Ideal for hanging pans, pots, and lids",
    "Space-saving design for organized kitchen storage",
    "Strong and durable metal construction",
    "Easy access to frequently used cookware",
    "Keeps kitchen neat and clutter-free",
    "Open design for better visibility and convenience"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹2474",
  oldPrice: "₹2500",

  sku: "7770",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Pan%20Hanger%20Rack%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: " Metal" },
    { label: "Finish", value: "" },
    { label: "Mounting Type", value: "Wall / Cabinet" },
    { label: "Usage", value: "Cookware Hanging" },
    { label: "Design", value: "Open Rack" },
    { label: "Load Capacity", value: "Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "PAN HANGER RACK",
      code: "7770",
      size: "",
      finish: ""
    },
   
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Pan Hanger Rack?",
      answer:
        "It is a kitchen accessory used to hang pans, pots, and lids for easy access and organized storage."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in kitchens on walls or inside cabinets to organize cookware efficiently."
    },
    {
      question: "What are the advantages?",
      answer:
        "It saves space, keeps cookware organized, and allows quick and easy access."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing frying pans, saucepans, woks, lids, and other cookware."
    }
  ]
},
  {
  code: "PO-22",
  name: "TOP MOUNTED DOUBLE LINER TROUSER HANGER",
  category: "pull-out",

  mainImage: mainImg21,
  thumbnails: [thumb43, thumb44],

  short:
    "Top Mounted Double Liner Trouser Hanger is a smart wardrobe accessory designed to keep trousers neatly organized and easily accessible. Installed at the top of the cabinet, it features dual hanging rods that allow multiple trousers to be stored efficiently. The smooth sliding mechanism ensures convenience, while the sturdy construction provides long-lasting performance.",

  features: [
    "Top-mounted design for wardrobe installation",
    "Double liner rods for hanging multiple trousers",
    "Smooth pullout mechanism for easy access",
    "Strong and durable metal construction",
    "Space-saving solution for wardrobes",
    "Keeps trousers organized and wrinkle-free"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹4416",
  oldPrice: "₹4500",

  sku: "7715",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Trouser%20Hanger%20Double%20Liner%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Steel / Metal" },
    { label: "Finish", value: "" },
    { label: "Mounting Type", value: "Top Mounted" },
    { label: "Usage", value: "Trouser Hanging" },
    { label: "Capacity", value: "Multiple Trousers" },
    { label: "Load Capacity", value: "Light to Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "DOUBLE LINER TROUSER HANGER",
      code: "7715",
      size: "",
      finish: ""
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Top Mounted Double Liner Trouser Hanger?",
      answer:
        "It is a wardrobe accessory designed to hang and organize multiple trousers using dual hanging rods with smooth pull-out access."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in wardrobes or closets to keep trousers organized and easily accessible."
    },
    {
      question: "What are the advantages?",
      answer:
        "It saves space, keeps trousers wrinkle-free, and provides smooth sliding for convenient use."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for hanging trousers, pants, and similar garments."
    }
  ]
},
 

  {
  code: "PO-23",
  name: "TOP MOUNTED PULLOUT TROUSER HANGER (SINGLE)",
  category: "pull-out",

  mainImage: mainImg22,
  thumbnails: [thumb45, thumb46],

  short:
    "Top Mounted Pullout Trouser Hanger (Single) is a compact wardrobe accessory designed to organize trousers neatly in a single row. It is installed at the top of the wardrobe and slides out smoothly, allowing easy access to each trouser. Its space-saving design makes it ideal for modern wardrobes while keeping clothes wrinkle-free and well arranged.",

  features: [
    "Top-mounted design for wardrobe installation",
    "Single liner for organizing trousers in one row",
    "Smooth pullout mechanism for easy access",
    "Compact and space-saving design",
    "Strong and durable construction",
    "Keeps trousers neat and wrinkle-free"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹3885",
  oldPrice: "₹4200",

  sku: "7714",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Single%20Trouser%20Hanger%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Steel / Metal" },
    { label: "Finish", value: "Chrome" },
    { label: "Mounting Type", value: "Top Mounted" },
    { label: "Usage", value: "Trouser Hanging" },
    { label: "Capacity", value: "Single Row" },
    { label: "Load Capacity", value: "Light Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "SINGLE TROUSER HANGER",
      code: "7714",
      size: "",
      finish: ""
    },
   
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Top Mounted Pullout Trouser Hanger (Single)?",
      answer:
        "It is a wardrobe accessory designed to hang trousers in a single row with smooth pull-out access."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed in wardrobes or closets to organize trousers efficiently."
    },
    {
      question: "What are the advantages?",
      answer:
        "It saves space, keeps trousers wrinkle-free, and allows easy access to each item."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for hanging trousers, pants, and similar garments."
    }
  ]
},

{
  code: "PO-24",
  name: "SIDE MOUNTED PULLOUT TROUSER HANGER (SINGLE)",
  category: "pull-out",

  mainImage: mainImg23,
  thumbnails: [thumb47, thumb48],

  short:
    "Side Mounted Pullout Trouser Hanger (Single) is a smart wardrobe accessory designed to organize trousers neatly in a single row. Installed on the side panel of the wardrobe, it provides smooth pullout access for convenience. Its compact design saves space while keeping trousers wrinkle-free and well arranged.",

  features: [
    "Side-mounted design for wardrobe installation",
    "Single liner for organizing trousers in one row",
    "Smooth pullout mechanism for easy access",
    "Compact and space-saving design",
    "Strong and durable construction",
    "Keeps trousers neat and wrinkle-free"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹3588",
  oldPrice: "₹4200",

  sku: "7716",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Side%20Mounted%20Trouser%20Hanger%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Steel / Metal" },
    { label: "Finish", value: "Chrome" },
    { label: "Mounting Type", value: "Side Mounted" },
    { label: "Usage", value: "Trouser Hanging" },
    { label: "Capacity", value: "Single Row" },
    { label: "Load Capacity", value: "Light Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "SIDE MOUNTED TROUSER HANGER",
      code: "7716",
      size: "",
      finish: ""
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Side Mounted Pullout Trouser Hanger (Single)?",
      answer:
        "It is a wardrobe accessory designed to hang trousers in a single row with smooth pull-out access from the side of the cabinet."
    },
    {
      question: "Where is it used?",
      answer:
        "It is installed on the side panel of wardrobes or closets to organize trousers efficiently."
    },
    {
      question: "What are the advantages?",
      answer:
        "It saves space, keeps trousers wrinkle-free, and allows easy access to each item."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for hanging trousers, pants, and similar garments."
    }
  ]
},


{
  code: "PO-25",
  name: "360° ROTATING SHOE RACK",
  category: "pull-out",

  mainImage: mainImg24,
  thumbnails: [thumb49, thumb50],

  short:
    "The 360° Rotating Shoe Rack is an innovative storage solution designed to organize footwear efficiently while maximizing space. Its rotating mechanism allows easy access to shoes from all sides, making it convenient to select and store multiple pairs. Built with strong and durable materials, it ensures stability and long-lasting performance. Ideal for modern wardrobes and walk-in closets, this rack keeps shoes neatly arranged while adding a smart and stylish touch to your storage space.",

  features: [
    "360° rotating design for easy access",
    "Space-saving and efficient storage solution",
    "Strong and durable construction",
    "Ideal for wardrobes and walk-in closets",
    "Keeps shoes neatly organized",
    "Smooth and convenient rotation mechanism"
  ],

  // ✅ VIDEO ADD
  video: "https://www.youtube.com/embed/YOUR_VIDEO_ID",

  // ✅ PRICE
  price: "₹21742",
  oldPrice: "₹22290",

  // ✅ META
  sku: "7711-7713",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=360°%20Rotating%20Shoe%20Rack%20Inquiry",

  // ✅ ADDITIONAL INFO (TABLE)
  specifications: [
    { label: "Material", value: "Metal Frame" },
    { label: "Rotation", value: "360 Degree" },
    { label: "Usage", value: "Shoe Storage" },
    { label: "Installation", value: "Wardrobe / Closet" },
    { label: "Finish", value: "Premium Coated" }
  ],

  // ✅ SPEC TABLE (OPTIONAL)
  specTable: [
    {
      item: "360° Rotating Shoe Rack",
      code: "7711",
      size: "3 Layer",
      finish: "Matte / Chrome"
    },
     {
      item: "360° Rotating Shoe Rack",
      code: "7712",
      size: "10 Layer",
      finish: "Matte / Chrome"
    },
     {
      item: "360° Rotating Shoe Rack",
      code: "7713",
      size: "12 Layer",
      finish: "Matte / Chrome"
    },

  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a 360° Rotating Shoe Rack?",
      answer:
        "A 360° Rotating Shoe Rack is a modular storage unit designed to hold shoes while allowing complete rotation for easy access to all pairs."
    },
    {
      question: "Where is the 360° Rotating Shoe Rack used?",
      answer:
        "It is commonly placed in wardrobes, closets, or entryways to organize shoes efficiently and save floor space."
    },
    {
      question: "What are the advantages of a 360° Rotating Shoe Rack?",
      answer:
        "It provides easy access to all shoes, saves space, keeps footwear organized, and allows quick selection without bending or moving other shoes."
    },
    {
      question: "What items can be stored in the 360° Rotating Shoe Rack?",
      answer:
        "It is ideal for storing all types of footwear including sneakers, sandals, boots, and formal shoes."
    }
  ]
},
{
  code: "PO-26",
  name: "SHOE RACK",
  category: "pull-out",

  mainImage: mainImg25,
  thumbnails: [thumb51, thumb52],

  short:
    "Shoe Rack is a practical storage solution designed to keep footwear neatly organized and easily accessible. It helps maintain a clean and clutter-free space by arranging shoes in an orderly manner. Made from durable materials, it offers strong support and long-lasting performance, making it ideal for wardrobes, entryways, and storage areas.",

  features: [
    "Durable and sturdy construction",
    "Space-saving storage design",
    "Keeps shoes organized and easy to access",
    "Suitable for wardrobes, closets, and entryways",
    "Modern and functional design",
    "Easy installation and maintenance"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹8239",
  oldPrice: "₹9080",

  sku: "7706",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Shoe%20Rack%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Metal / Steel" },
    { label: "Finish", value: "Chrome / Powder Coated" },
    { label: "Usage", value: "Shoe Storage" },
    { label: "Installation", value: "Wardrobe / Entryway" },
    { label: "Capacity", value: "Multiple Pairs" },
    { label: "Load Capacity", value: "Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "SHOE RACK",
      code: "7706",
      size: "600mm",
      finish: "Chrome"
    },
    {
      item: "SHOE RACK",
      code: "7707",
      size: "900mm",
      finish: "Powder Coated"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Shoe Rack?",
      answer:
        "A Shoe Rack is a storage unit designed to organize and store footwear in a neat and accessible way."
    },
    {
      question: "Where is it used?",
      answer:
        "It is commonly placed in wardrobes, closets, entryways, or storage areas."
    },
    {
      question: "What are the advantages?",
      answer:
        "It keeps shoes organized, saves space, and makes it easy to access footwear."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing sneakers, sandals, boots, and formal shoes."
    }
  ]
},

{
  code: "PO-27",
  name: "Extenbable DECORATION SHELF",
  category: "pull-out",

  mainImage: mainImg26,
  thumbnails: [thumb53, thumb54],

  short:
    "Extenbable Decoration Shelf is a premium storage and display solution designed to maximize space while enhancing interior aesthetics. It  provides an elegant platform for displaying decorative items, plants, photo frames, trophies, and other accessories. Built with durable materials and a modern finish, it offers both functionality and style for homes, offices, wardrobes, and display areas.",

  features: [
    "Modern and elegant design",
    "Ideal for decorative item display",
    "Strong and durable construction",
    "Space-saving storage solution",
    "Suitable for homes, offices, and showrooms",
    "Easy installation and maintenance"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/eNM5rSwFaOA",

  // ✅ PRICE
  price: "₹7475",
  oldPrice: "₹9805",

  sku: "7764",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Decoration%20Shelf%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Aluminium / Steel" },
    { label: "Finish", value: "Matt Grey" },
    { label: "Type", value: "Decoration Shelf" },
    { label: "Installation", value: "Cabinet Mounted" },
    { label: "Load Capacity", value: "Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Extenbable DECORATION SHELF",
      code: "7764",
      size: "600mm",
      finish: "Matt Grey"
    },
   
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Extendable Decoration Shelf?",
      answer:
        "It is a shelf designed to display decorative items such as photo frames, plants, trophies, and showpieces."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is commonly used in living rooms, bedrooms, wardrobes, offices, and display cabinets."
    },
    {
      question: "What are its advantages?",
      answer:
        "It enhances interior aesthetics, keeps decorative items organized, and utilizes available space efficiently."
    },
    {
      question: "What items can be displayed on it?",
      answer:
        "It is ideal for displaying photo frames, plants, trophies, collectibles, vases, and decorative accessories."
    }
  ]
},



{
  code: "PO-28",
  name: "WOODEN PANTRY CHROME",
  category: "pull-out",

  mainImage: mainImg27,
  thumbnails: [thumb55, thumb56],

  short:
    "Wooden Pantry Chrome is a stylish and functional storage solution designed for modular kitchen pantry cabinets. It combines elegant wooden shelves with a strong chrome frame, offering durability with a premium look. The smooth pull-out mechanism provides easy access to groceries, jars, and kitchen essentials while keeping the pantry well organized.",

  features: [
    "Premium wooden shelves with chrome frame",
    "Ideal for groceries, jars, and kitchen essentials",
    "Smooth pull-out mechanism for easy access",
    "Strong and durable construction",
    "Enhances modular kitchen pantry aesthetics",
    "Maximizes vertical storage space"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹20199",
  oldPrice: "₹21000",

  sku: "7090-7091",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Wooden%20Pantry%20Chrome%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Wood + Chrome Metal" },
    { label: "Finish", value: "Chrome + Wooden" },
    { label: "Usage", value: "Pantry Storage" },
    { label: "Installation", value: "Tall Cabinet" },
    { label: "Capacity", value: "High Storage" },
    { label: "Load Capacity", value: "Heavy Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "WOODEN PANTRY CHROME",
      code: "7090",
      size: "450mmx6L",
      finish: "Chrome + Wood"
    },
    {
      item: "WOODEN PANTRY CHROME",
      code: "7091",
      size: "600mmx6L",
      finish: "Chrome + Wood"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is Wooden Pantry Chrome?",
      answer:
        "It is a modular kitchen pantry storage system with wooden shelves and a chrome frame."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is mainly installed in tall pantry cabinets of modular kitchens."
    },
    {
      question: "What items can be stored?",
      answer:
        "It can store groceries, jars, bottles, containers, and kitchen essentials."
    },
    {
      question: "Is the structure durable?",
      answer:
        "Yes, the chrome frame and wooden shelves provide strong and long-lasting support."
    },
    {
      question: "Does it provide easy access?",
      answer:
        "Yes, the pull-out system allows easy access to all stored items."
    }
  ]
},




  {
  code: "PO-29",
  name: "PREMIUM GLASS ELEVATOR",
  category: "pull-out",

  mainImage: mainImg28,
  thumbnails: [thumb57, thumb58],

  short:
    "Premium Glass Elevator is an advanced modular kitchen storage solution designed for wall cabinets. It features a smooth lift-down mechanism with elegant glass shelves that bring stored items within easy reach. Built with high-quality materials, it enhances accessibility while adding a premium and modern look to kitchen interiors.",

  features: [
    "Premium glass shelves for modern aesthetics",
    "Smooth lift-down elevator mechanism",
    "Ideal for modular kitchen wall cabinets",
    "Strong and durable construction",
    "Efficient use of upper cabinet space",
    "Keeps kitchen items organized and accessible"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹19780",
  oldPrice: "₹20000",

  sku: "7742-7743",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Premium%20Glass%20Elevator%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Glass + Metal Frame" },
    { label: "Finish", value: "Premium Glass + Chrome" },
    { label: "Usage", value: "Wall Cabinet Storage" },
    { label: "Installation", value: "Wall Mounted Cabinet" },
    { label: "Load Capacity", value: "Medium Duty" },
    { label: "Mechanism", value: "Lift Down Elevator" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "PREMIUM GLASS ELEVATOR",
      code: "7742",
      size: "600mm",
      finish: "Glass + Chrome"
    },
    {
      item: "PREMIUM GLASS ELEVATOR",
      code: "7743",
      size: "900mm",
      finish: "Glass + Chrome"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Premium Glass Elevator?",
      answer:
        "It is a modular kitchen storage system with glass shelves that move downward for easy access."
    },
    {
      question: "Where can it be installed?",
      answer:
        "It is mainly installed in upper wall cabinets of modular kitchens."
    },
    {
      question: "What items can be stored?",
      answer:
        "It can store cups, jars, containers, and kitchen essentials."
    },
    {
      question: "Does it improve accessibility?",
      answer:
        "Yes, the lift-down mechanism brings items within easy reach."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made with high-quality materials for long-lasting performance."
    }
  ]
},


   {
  code: "PO-30",
  name: "GREY GLASS PULLOUT (SIDE MOUNTED, 2 LAYER)",
  category: "pull-out",

  mainImage: mainImg29,
  thumbnails: [thumb59, thumb60],

  short:
    "Grey Glass Pullout (Side Mounted, 2 Layer) is a sleek and functional modular kitchen storage solution designed to organize kitchen essentials efficiently. Featuring stylish grey glass baskets with a strong side-mounted mechanism, it ensures smooth sliding and easy access while maintaining a modern and premium cabinet look.",

  features: [
    "Elegant grey glass basket design",
    "Side-mounted channels for smooth operation",
    "2-layer storage for better organization",
    "Strong and durable construction",
    "Ideal for modular kitchen cabinets",
    "Keeps items organized and easily accessible"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹4930",
  oldPrice: "₹5000",

  sku: "7597-7598",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Grey%20Glass%20Pullout%202%20Layer%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Glass + Metal Frame" },
    { label: "Finish", value: "Grey Glass" },
    { label: "Layers", value: "2 Layer" },
    { label: "Mounting", value: "Side Mounted" },
    { label: "Usage", value: "Kitchen Cabinet Storage" },
    { label: "Load Capacity", value: "Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "GREY GLASS PULLOUT",
      code: "7597",
      size: "200mm",
      finish: "Grey Glass"
    },
    {
      item: "GREY GLASS PULLOUT",
      code: "7598",
      size: "200mm",
      finish: "Grey Glass"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is Grey Glass Pullout (Side Mounted, 2 Layer)?",
      answer:
        "It is a modular kitchen storage system with two grey glass baskets and a side-mounted pull-out mechanism."
    },
    {
      question: "Where can it be installed?",
      answer:
        "It is mainly installed inside modular kitchen cabinets."
    },
    {
      question: "What items can be stored?",
      answer:
        "It can store bottles, jars, containers, and kitchen essentials."
    },
    {
      question: "What is the benefit of side mounting?",
      answer:
        "It provides smooth sliding and stable operation."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made with strong materials for long-lasting performance."
    }
  ]
},

    {
  code: "PO-31",
  name: "WOODEN PANTRY GREY",
  category: "pull-out",

  mainImage: mainImg30,
  thumbnails: [thumb61, thumb62],

  short:
    "Wooden Pantry Grey is a premium modular kitchen storage system designed for tall pantry cabinets. It features elegant grey wooden baskets with a strong frame, offering durability along with a modern aesthetic. The smooth pull-out mechanism ensures easy access to groceries and kitchen essentials while keeping the pantry organized and efficient.",

  features: [
    "Grey wooden baskets for a modern premium look",
    "Ideal for groceries, jars, bottles, and containers",
    "Smooth pull-out mechanism for easy access",
    "Strong and durable construction",
    "Perfect for tall pantry cabinets",
    "Maximizes vertical storage efficiently"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/PM5WhdOWrqo",

  // ✅ PRICE
  price: "₹16609",
  oldPrice: "₹20199",

  sku: "7090-7091",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Wooden%20Pantry%20Grey%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Wood + Metal Frame" },
    { label: "Finish", value: "Grey Wooden" },
    { label: "Usage", value: "Pantry Storage" },
    { label: "Installation", value: "Tall Cabinet" },
    { label: "Load Capacity", value: "Heavy Duty" },
    { label: "Type", value: "Pull-Out Pantry" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "WOODEN PANTRY GREY",
      code: "7090",
      size: "450mm x 6L",
      finish: "Grey Wooden"
    },
    {
      item: "WOODEN PANTRY GREY",
      code: "7091",
      size: "600mm X 6L",
      finish: "Grey Wooden"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is Wooden Pantry Grey?",
      answer:
        "It is a modular kitchen pantry storage system with grey wooden baskets designed for tall cabinets."
    },
    {
      question: "Where can it be installed?",
      answer:
        "It is mainly installed in tall pantry cabinets of modular kitchens."
    },
    {
      question: "What items can be stored?",
      answer:
        "It can store groceries, jars, bottles, containers, and kitchen essentials."
    },
    {
      question: "Does it provide easy access?",
      answer:
        "Yes, the pull-out system allows easy access to all stored items."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is built with strong materials for long-lasting use."
    }
  ]
},
{
  code: "PO-31",
  name: " DECORATION SHELF",
  category: "pull-out",

  mainImage: mainImg31,
  thumbnails: [thumb63, thumb64],

  short:
    "Decoration Shelf is a stylish storage solution designed to display decorative items while enhancing the overall look of your space. It provides a perfect platform for placing showpieces, photo frames, plants, and décor accessories. With its modern design and durable construction, it adds both functionality and elegance to interiors.",

  features: [
    "Modern and elegant design",
    "Space-saving wall or cabinet storage",
    "Strong and durable construction",
    "Suitable for homes, offices, and showrooms",
    "Enhances interior décor aesthetics",
    "Easy installation and maintenance"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/8SF4RSWCx88",

  // ✅ PRICE
  price: "₹8656",
  oldPrice: "₹9805",

  sku: "7702-7703",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Decoration%20Shelf%20Inquiry",

  // ✅ ADDITIONAL INFO
  specifications: [
    { label: "Material", value: "Wood / Metal" },
    { label: "Finish", value: "Matte / Glossy" },
    { label: "Usage", value: "Decor Display" },
    { label: "Installation", value: "Wall Mounted / Cabinet" },
    { label: "Load Capacity", value: "Light to Medium Duty" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "DECORATION SHELF",
      code: "7702",
      size: "600mm",
      finish: ""
    },
    {
      item: "DECORATION SHELF",
      code: "7703",
      size: "900mm",
      finish: ""
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Decoration Shelf?",
      answer:
        "It is a shelf designed to display decorative items such as photo frames, plants, and showpieces."
    },
    {
      question: "Where is it used?",
      answer:
        "It is commonly used in living rooms, bedrooms, offices, and showrooms."
    },
    {
      question: "What are the advantages?",
      answer:
        "It enhances interior décor, keeps items organized, and utilizes space efficiently."
    },
    {
      question: "What items can be displayed?",
      answer:
        "It is ideal for displaying vases, photo frames, plants, trophies, and decorative accessories."
    }
  ]
},

];
